import gql from 'graphql-tag';

export const FRAGMENT_PERFORMANCE_CENTER_TEXT_VARIATIONS_RESULT = gql`
  fragment PerformanceCenterTextVariationsResult on PerformanceCenterTextVariationsResult {
    id
    text
    weightedAvgCtr
    lifetimeImpressions
    textType
    startDate
    sourceAnyword
    numberOfInstances
    keywords
    campaignNames
    lifetimeConversions
    sortIndex
    performance
  }
`;

export const FRAGMENT_REVIEWS_ACCOUNT = gql`
  fragment PerformanceCenterReviewAccount on PerformanceCenterReviewAccount {
    id
    siteType
    urls
    productTitle
  }
`;

export const FRAGMENT_WEBSITE_ACCOUNT = gql`
  fragment PerformanceCenterWebsiteAccount on PerformanceCenterWebsiteAccount {
    id
    websiteType
    urls
    pageTitles
  }
`;
export const FRAGMENT_RESOURCE = gql`
  fragment PerformanceCenterResource on PerformanceCenterResource {
    id
    name
    dataSource
    connected
  }
`;

export const FRAGMENT_CUSTOMER_RESOURCE = gql`
  fragment PerformanceCenterCustomerResource on PerformanceCenterCustomerResource {
    id
    content
    contentType
    name
    status
    tags
    file {
      originalUrl
      compressedUrl
      thumbnailUrl
      imageWidth
      imageHeight
      fileSize
      fileType
      fileName
      pageCount
    }
  }
`;

export const FRAGMENT_PERFORMANCE_CENTER_INTEGRATION_REQUEST = gql`
  fragment PerformanceCenterIntegrationRequest on PerformanceCenterIntegrationRequest {
    id
    accountId
    customDatasetId
    avgCompletionPercent
    campaigns {
      id
      name
    }
    campaignsCopyImpressions {
      campaignName
      copyText
      impressions
    }
    dataSource
    errors
    status
    updatedAt
    connectedOn
  }
`;

export const FRAGMENT_PERFORMANCE_CENTER_INTEGRATION_REQUEST_ONLY_STATUS = gql`
  fragment PerformanceCenterIntegrationRequestStatus on PerformanceCenterIntegrationRequest {
    id
    status
    errors
    avgCompletionPercent
  }
`;

export const FRAGMENT_INTEGRATION_ACCOUNT = gql`
  fragment PerformanceCenterIntegrationAccount on PerformanceCenterIntegrationAccount {
    status
    accountId
    accountName
    accountType
    url
    connectedOn
  }
`;
